import { Delete } from "@mui/icons-material";
import { Autocomplete, IconButton, InputAdornment, TableCell, TableRow, TextField } from "@mui/material";
import { cloneDeep } from "lodash";
import react, { useState } from "react";
import { IComboBoxOption, IDispatchMaterialGroup } from "../../interfaces";
import { Format } from "../../utils";
import { MaterialIdentifiers } from "../Shared/MaterialIdentifiers";


interface IMaterialGroupTableRow {
    dispatchMaterialGroup: IDispatchMaterialGroup,
    returnStatuses: IComboBoxOption[],
    onUpdate: (materialGroup: IDispatchMaterialGroup) => void,
    expectedReturn: boolean,
    valueOnDispatch: boolean,
    readonly: boolean,
    onRemove: () => void,
    key: any
}

export const MaterialGroupTableRow: React.FC<IMaterialGroupTableRow> = ({
    dispatchMaterialGroup,
    returnStatuses,
    onUpdate,
    expectedReturn,
    valueOnDispatch,
    readonly,
    onRemove,
    key
}) => {

    const [valueActive, setValueActive] = useState(false);


    const handleChange = (name: string, value: string | number | null) => {


        value = value === "" ? null : value;

        let currentGroup = cloneDeep(dispatchMaterialGroup) as any;

        currentGroup[name] = value;

        onUpdate(currentGroup);
    }

    const handleChangeReturnStatus = (value: string | null) => {

        let currentGroup = cloneDeep(dispatchMaterialGroup);

        currentGroup.expectedReturnState = returnStatuses.filter(x => x.value === value)[0];

        onUpdate(currentGroup);
    }



    const materialGroup = dispatchMaterialGroup.materialGroup;

    return (


        <TableRow className="material-row" key={key}>
            <TableCell>
                <div>
                    <p><strong>{materialGroup.title}</strong></p>
                    <small>{materialGroup.subtitle}</small>
                    <small>{materialGroup.subtitle2}</small>
                </div>
            </TableCell>
            <TableCell>
                <p>{materialGroup.classes} </p>
            </TableCell>
            <TableCell>
                <p>{materialGroup.spareType}</p>
            </TableCell>
            <TableCell>
                <MaterialIdentifiers materialGroup={materialGroup} />
            </TableCell>
            <TableCell>
                <p>{materialGroup.state}</p>
            </TableCell>
            <TableCell>
                <p>
                    {dispatchMaterialGroup.requestedQuantity}
                    {materialGroup.materials &&
                        <span>({materialGroup.materials[0].unitOfQuantity.value})</span>
                    }
                </p>
            </TableCell>

            {expectedReturn === true &&
                <TableCell>
                    {readonly ?
                        <span>{dispatchMaterialGroup.expectedReturnState?.value}</span>
                        :
                        <Autocomplete
                            id="material-status"
                            options={returnStatuses.map(x => x.value)}
                            value={dispatchMaterialGroup.expectedReturnState?.value || null}
                            onChange={(_, value) => handleChangeReturnStatus(value)}
                            readOnly={readonly}
                            renderInput={(params) => <TextField
                                {...params}
                                required
                                variant="standard"
                            />}
                        />
                    }
                </TableCell>
            }


            {valueOnDispatch === true &&
                <TableCell>
                    {readonly ?
                        <span>{dispatchMaterialGroup.valueOnDispatch}</span>
                        :

                        <TextField
                            id="material-status"
                            variant="standard"
                            value={valueActive ? dispatchMaterialGroup.valueOnDispatch : Format.currency(dispatchMaterialGroup.valueOnDispatch)}

                            onChange={(e) => handleChange("valueOnDispatch", Number.parseFloat(e.target.value))}
                            disabled={readonly}
                            onClick={() => setValueActive(true)}
                            onBlur={() => setValueActive(false)}

                            required
                            InputProps={{
                                startAdornment: <InputAdornment position="start" > £</InputAdornment>
                            }}
                            inputProps={{ min: 0.01, step: 'any' }}
                            type={valueActive ? "number" : "text"}
                        />

                    }
                </TableCell>
            }

            <TableCell>
                {!readonly && <>
                    <IconButton aria-label="remove material" onClick={onRemove}>
                        <Delete />
                    </IconButton>
                </>}
            </TableCell>
        </TableRow >
    );
}

